import { Component, OnInit } from '@angular/core';

import { MessagingService } from '../../services/messaging.service';

@Component({
  standalone: false,
  selector: 'app-referrer-portal',
  templateUrl: './referrer-portal.component.html',
  styleUrls: ['./referrer-portal.component.css']
})
export class ReferrerPortalComponent implements OnInit {

  constructor(
    private messagingService: MessagingService,
  ) {
  }

  ngOnInit() {
  }

}
